'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useOrderStore } from '@/store/useOrderStore';

export default function Header() {
  const { currentStep, totalSteps } = useOrderStore();

  return (
    <header className="sticky top-0 z-50 bg-[#1A3A5C] text-white">
      <div className="max-w-[1200px] mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link href="/" className="hover:opacity-50 transition-opacity flex-shrink-0">
            <Image
              src="/images/logo_d.png"
              alt="당나귀배송"
              width={240}
              height={64}
              className="h-11 sm:h-16 w-auto"
              priority
            />
          </Link>
          <div>
            <div className="text-lg font-bold">배송 신청</div>
            <div className="text-[10px] opacity-60 tracking-[3px] uppercase">reservation</div>
          </div>
        </div>
        <div className="w-12 h-12 rounded-full border-[3px] border-white/30 flex items-center justify-center">
          <span className="text-sm font-bold text-[#4DA3FF]">{currentStep}/{totalSteps}</span>
        </div>
      </div>
    </header>
  );
}
